import clsx from "clsx";
import { ButtonHTMLAttributes } from "react";
import styles from "./Button.module.scss";

export type ButtonProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "color"
> & {
  color?: ButtonColor;
  loading?: boolean;
};

export type ButtonColor = "green" | "red" | "white";

function Button({
  className,
  color = "white",
  loading,
  ...props
}: ButtonProps) {
  return (
    <button
      className={clsx(
        className,
        styles.base,
        color && styles[color],
        loading && styles.loading
      )}
      disabled={loading}
      {...props}
    />
  );
}

export default Button;
